import React from 'react';
import { useTranslation } from 'react-i18next';
import { appNamedRoutes } from 'routes';
import PageSubNav from 'components/nav/PageSubNav';

const GroupCohortsSubNav = () => {
  const { t } = useTranslation();
  const GROUP_AND_COHORT_PAGES = [
    {
      path: appNamedRoutes.groupcohortsReportGeneral,
      label: t('reports.subNav.general'),
    },
    {
      path: appNamedRoutes.groupcohortsReportOrganizationType,
      label: t('reports.subNav.groupedByOrganizationType'),
    },
  ];

  return (
    <PageSubNav items={GROUP_AND_COHORT_PAGES} />
  );
};

export default GroupCohortsSubNav;
